module.exports = __webpack_public_path__ + "static/how_to_alerts-1ba21fc4f64635cc72d95632638ea19f.png";